import m from 'mithril';
import BaseComponent from '../../BaseComponent';
import FilterSelectDropdownView, { DropdownListHost } from '../../FilterSelectDropdown/js/view/FilterSelectDropdownView';
import { FilterOption } from '../../FilterSelectDropdown/js/FilterSelectDropdown';
import normalizeString from "../../../helpers/normalizeString";

export default class FilterProjectUsersDropdown extends BaseComponent implements DropdownListHost {

    public static readonly SEARCH_THRESHOLD = 6;

    public options: FilterOption[] = [];
    public searchQuery = '';
    public highlightedIndex = -1;

    private $hiddenSelect: JQuery<HTMLSelectElement> | null = null;
    private rolesMount: HTMLElement | null = null;

    public init(): void {
        const roleInputId = this.$component.data('filter-role-input-id');
        const hiddenSelect = document.getElementById(roleInputId) as HTMLSelectElement | null;
        if (!hiddenSelect) {
            console.warn(`FilterProjectUsersDropdown: hidden select "${roleInputId}" not found`);
            return;
        }
        this.$hiddenSelect = $(hiddenSelect);
        this.options = this.parseOptions(hiddenSelect);

        this.rolesMount = this.$component.find('[data-filter-roles]').get(0) ?? null;
        if (!this.rolesMount) {
            return;
        }

        m.mount(this.rolesMount, new FilterSelectDropdownView(this));

        this.$component.parent().on('shown.bs.dropdown', () => {
            this.highlightedIndex = -1;
            m.redraw();
            this.focusSearch();
        });
    }

    public beforeRemove(): void {
        if (this.rolesMount) {
            m.mount(this.rolesMount, null);
        }
    }

    public toggle(option: FilterOption): void {
        option.selected = !option.selected;
        this.syncHiddenSelect();
    }

    public setSearchQuery(value: string): void {
        if (this.searchQuery !== value) {
            this.highlightedIndex = -1;
        }
        this.searchQuery = value;
    }

    public showSearch(): boolean {
        return this.options.length >= FilterProjectUsersDropdown.SEARCH_THRESHOLD;
    }

    public getFilteredOptions(): FilterOption[] {
        const q = normalizeString(this.searchQuery);
        if (q === '') {
            return this.options;
        }
        return this.options.filter(o => normalizeString(o.label).includes(q));
    }

    public getNavigableOptions(): FilterOption[] {
        return this.getFilteredOptions();
    }

    public moveHighlight(delta: number): void {
        const options = this.getNavigableOptions();
        if (options.length === 0) {
            this.highlightedIndex = -1;
            return;
        }
        if (this.highlightedIndex === -1) {
            this.highlightedIndex = delta > 0 ? 0 : options.length - 1;
            return;
        }
        this.highlightedIndex = (this.highlightedIndex + delta + options.length) % options.length;
    }

    private focusSearch(): void {
        this.$component.find('.filter-select-dropdown-search input').trigger('focus');
    }

    private parseOptions(select: HTMLSelectElement): FilterOption[] {
        const options: FilterOption[] = [];
        for (const optionEl of Array.from(select.options)) {
            if (optionEl.value === '') {
                continue;
            }
            options.push({
                value: optionEl.value,
                label: optionEl.textContent ?? optionEl.value,
                selected: optionEl.selected,
            });
        }
        return options;
    }

    private syncHiddenSelect(): void {
        if (!this.$hiddenSelect) {
            return;
        }
        const select = this.$hiddenSelect[0];
        const selectedValues = new Set(this.options.filter(o => o.selected).map(o => o.value));
        for (const optionEl of Array.from(select.options)) {
            optionEl.selected = selectedValues.has(optionEl.value);
        }
        this.$hiddenSelect.trigger('change');
    }
}
